import React, { useState } from 'react';

const Search = ({setSearchPopUp, regions, searchName, setSearchName}) => {
  const [searchStatus, setSearchStatus] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const showSuggestions = () => {
   if (suggestions) {
    const alphabeticalList = suggestions.sort((a, b) => a.node.regionName.localeCompare(b.node.regionName, 'sv'));
     let list = alphabeticalList.map((sug, index) => {
       return (
        <button 
          className='listItem' 
          key={`${sug}${index}`} 
          onClick={() => handleListItemClick(sug.node.regionName)}
        >
        {sug.node.regionName}
        </button>
       )
     })
     return list;
   }
  }

  const handleListItemClick = (name) => {
    setSearchName(name);
    setSuggestions([]);   

  }

  const handleChange = (e) => {
    e.preventDefault();
    setSearchName('');
    setSearchStatus('');
    setSearchPopUp(false);
    const regionName = e.target.value;
    regionName.length === 0 && setSuggestions([]);
    if (regionName.length > 0 ){
         let startsWith = regions.filter(reg => {
            if(reg.node.regionName){
              return reg.node.regionName.toLowerCase().slice(0,regionName.length) === regionName.toLowerCase()
            } else {
              return ''
            }
          });
      setSuggestions(startsWith);
    }
    setSearchName(regionName);
  }

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      handleSearch();
    }
  }
  const handleSearch = () => {
    let searchedRegion = '';
    if (searchName){
      searchedRegion = searchName.toLowerCase();
      const checkedRegion = regions.find(reg => {
        if (reg.node.regionName){
        return reg.node.regionName.toLowerCase() === searchedRegion
        } else {
          return ""
        }
      });
      if (checkedRegion){
        setSearchPopUp(true);
        setSearchName(checkedRegion.node.regionName);
        setSuggestions([]);
      }
      else{
        clear();
        setSearchStatus('Den sökta kommunen hittas inte.');
      }
    }
  }

  const clear = () => {
    setSearchName('');
    setSuggestions([]);
    setSearchStatus('');
  }
  return (
    <>
      <div className='search'>
        <label>
          <input 
            type='text' 
            placeholder='Kommun' 
            value={searchName} 
            className='searchField'  
            onChange={(e) => handleChange(e)} 
            onClick={()=> clear()} 
            onKeyUp={(e) => handleKeyPress(e)}
          />
        </label>
        <button 
          className='search-btn' 
          onClick={() => handleSearch()} 
        >
          Sök
        </button>
        {searchStatus && 
          <p className='search-not-found'>{searchStatus}</p>
        }
      </div>
      {suggestions && 
        <div className='suggestion-list'>
          {showSuggestions()}
        </div>
      }
    </>
  );
};

export default Search;